<form [formGroup]="subscriptionForm" [elementsOptions]="elementsOptions" ngxStripeCardGroup>
  <div class="d-flex flex-column mb-7 fv-row">
    <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
    ><span class="required">Name On Card</span
    ><i
      class="fas fa-exclamation-circle ms-2 fs-7"
      ngbTooltip="Specify a card holder's name"
    ></i></label
    ><input
    formControlName="nameOnCard"
    type="text"
    class="form-control form-control-solid"
    placeholder="Name on card"
    [ngClass]="{
        'is-invalid': subscriptionForm.controls['nameOnCard'].invalid && subscriptionForm.controls['nameOnCard'].touched,
        'is-valid': subscriptionForm.controls['nameOnCard'].valid
      }"
  />
    <div
      class="fv-plugins-message-container invalid-feedback"
      *ngIf="
        subscriptionForm.get('nameOnCard')?.hasError('required') &&
        subscriptionForm.get('nameOnCard')?.touched"
    >
      Name on card is required
    </div>
  </div>
  <div class="d-flex flex-column mb-7 fv-row">
    <label class="required fs-6 fw-bold form-label mb-2">Card Number</label>
    <div class="position-relative">
      <ngx-stripe-card-number [options]="cardOptions" (change)="onChange($event, 'card-number')" containerClass="form-control form-control-solid"></ngx-stripe-card-number>
      <div
        class="fv-plugins-message-container invalid-feedback"
        *ngIf="cardNumberError"
      >
        {{cardNumberError}}
      </div>

    </div>
  </div>
  <div class="row mb-10">
    <div class="col-md-6 fv-row">
      <label class="required fs-6 fw-bold form-label mb-2"
      >Expiration Date</label
      >
      <div class="row fv-row">
        <div class="col-12">
          <ngx-stripe-card-expiry [options]="cardOptions" (change)="onChange($event, 'card-expiry')" containerClass="form-control form-control-solid"></ngx-stripe-card-expiry>
          <div
            class="fv-plugins-message-container invalid-feedback"
            *ngIf="cardExpiryError"
          >
            {{cardExpiryError}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 fv-row">
      <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
      ><span class="required">CVV</span
      ><i
        class="fas fa-exclamation-circle ms-2 fs-7"
        ngbTooltip="Enter a card CVV code"
      ></i
      ></label>

      <ngx-stripe-card-cvc [options]="cardOptions" (change)="onChange($event, 'card-cvc')" containerClass="form-control form-control-solid"></ngx-stripe-card-cvc>
      <div
        class="fv-plugins-message-container invalid-feedback"
        *ngIf="cardCVCError"
      >
        {{cardCVCError}}
      </div>

    </div>

  </div>

  <div class="text-center mt-2">
    <button [disabled]="!cardFormValid() || (isProcessing$ | async)" (click)="updatePaymentMethod()" class="btn btn-theme btn-lg btn-rounded">

      <ng-container *ngIf="(isProcessing$ | async) === false">
        <span class="indicator-label">Update Payment Method</span>
      </ng-container>
      <ng-container *ngIf="isProcessing$ | async">
              <span class="indicator-progress" [style.display]="'block'">
                Please wait...
                <span
                  class="spinner-border spinner-border-sm align-middle ms-2"
                ></span>
              </span>
      </ng-container>

    </button>
    <h4 class="text-primary fw-bold fs-7 mt-10 text-center">Any old details will be overwritten and removed.</h4>
  </div>


</form>

<ng-container *nzModalFooter></ng-container>
